import { Navigate } from "react-router";
import { useGetTimberStorageQuery } from "../../../apis/TimberStorage.api";
import { PrimaryTimberStorage, TimberStorage } from "../../../types/models/TimberStorage";
import GradientCircularProgress from "../../../../share/components/progress/GradientCircularProgress";

export const TimberStorageScoped = () => {
    const {
        data,
    } = useGetTimberStorageQuery(PrimaryTimberStorage.fromPath('scoped'))

    if (data) {
        const url = `/dashboard/timber-storages/${data.id}?scoped=true`
        return <Navigate to={url} replace/>
    } else {
        return <>
            <GradientCircularProgress/>
        </>
    }
}
export default TimberStorageScoped;
